// extracted by mini-css-extract-plugin
export var orderDetails = "_nn-2";
export var orderImage = "_nn-1";
export var orderMeta = "_nn-3";
export var orderSummary = "_nn-0";
export var rightArrow = "_nn-4";